function useLocalStorage() {
  const getData = (key) => JSON.parse(localStorage.getItem(key));
  const setData = (key, value) => localStorage.setItem(key, JSON.stringify(value));
  return { getData, setData };
}

export default useLocalStorage;
